import { hashKey } from '@tanstack/react-query';

/**
 * Two views of the same set, differing only by which page of it is being read. `pageKey` is
 * whatever the caller paginates by — `page` for an offset list, `pageToken` for a Jira cursor.
 * Every other key defines the population, so a change there is a different question and the
 * previous answer must leave the screen rather than stand under the new filters.
 */
export const samePopulation = <TFilters extends object>(
  pageKey: keyof TFilters,
  previous: TFilters | undefined,
  next: TFilters,
): boolean => {
  if (!previous) return false;

  const { [pageKey]: _previousPage, ...restPrevious } = previous;
  const { [pageKey]: _nextPage, ...restNext } = next;

  // react-query's own hash: order-independent and recursive, where a sorted `JSON.stringify`
  // replacer would blank nested objects and call two different date ranges the same page.
  return hashKey([restPrevious]) === hashKey([restNext]);
};
